export const requestTiktokApi = (params: any) => {
    return fetch("/api/analysis/tiktokApi", { method: "POST", body: params });
};

export const requestImpactApi = (params: any) => {
    return fetch("/api/analysis/impactApi", {
        method: "POST",
        body: JSON.stringify(params),
    });
};

export const requestImpactUpdateApi = (params: any) => {
    return fetch("/api/analysis/impactUpdateApi", {
        method: "POST",
        body: JSON.stringify(params),
    });
};
